parseNotificationMessageMarkdown